<template>
  <div class="product_addition" >
    <el-divider content-position="left">产品附加管理</el-divider>
      <el-select style="width:auto; margin-left: .2rem"
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入标题"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.title"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
    <el-button type="primary" size="mini" @click="handleAddOpen" style="margin-bottom: .2rem;float: right">添加</el-button>
    <el-table :data="ProductAdditionList" size="medium" border style="width: 100%">
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label">
      </el-table-column>
      <el-table-column prop="status" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="修改" placement="top">
          <el-button
            size="mini"
            icon="el-icon-edit"
            type="primary"
            circle
            @click="handleEdit(scope.$index, scope.row)">
          </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="pageOption.total"
        :page-size="pageOption.pageSize"
        :page-sizes="[10, 15, 30, 50, 100]"
        background
      >
    </el-pagination>
    <el-drawer
      title="添加"
      :visible.sync="addDrawer"
      :direction="direction"
      :before-close="handleAddDrawerClose"
      size="50%"
      class="add-drawer"
      >
      <div class="m-tabs-content" >
      <el-form>
        <el-form-item label="请输入标题">
            <el-input placeholder="请输入标题" v-model="addData.addition_title" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="请输入简介">
            <el-input type="textarea" placeholder="请输入简介" v-model="addData.addition_contract" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="PC端产品办理链接">
            <el-input type="textarea" placeholder="请输入PC端产品办理链接" v-model="addData.pc_link" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="小程序端产品办理链接">
            <el-input type="textarea" placeholder="请输入小程序端产品办理链接" v-model="addData.mini_link" size="mini" clearable></el-input>
        </el-form-item>
        <el-divider content-position="left">PC详情页</el-divider>
          <vue-ueditor-wrap v-model="addData.addition_desc" :config="myConfig" style="margin-bottom:.2rem"></vue-ueditor-wrap>
        <el-divider content-position="left">微信小程序详情页</el-divider>
          <vue-ueditor-wrap v-model="addData.we_desc" :config="myWeConfig"></vue-ueditor-wrap>
        <el-form-item label="是否显示">
          是
          <el-switch
            v-model="addData.status"
            active-color="#ff4949"
            inactive-color="#13ce66"
          >
          </el-switch>
          否
        </el-form-item>
        <div class="addCon" style="margin-right: .15rem">
          <el-button type="primary" size="mini" @click="handleAdd">保存</el-button>
        </div>
      </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"
      :visible.sync="editDrawer"
      :direction="direction"
      :before-close="handleEditDrawerClose"
      size="50%"
      class="add-drawer"
      >
      <div class="m-tabs-content" >
      <el-form>
        <el-form-item label="请输入标题">
            <el-input placeholder="请输入标题" v-model="saveData.addition_title" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="请输入简介">
            <el-input type="textarea" placeholder="请输入简介" v-model="saveData.addition_contract" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="PC端产品办理链接">
            <el-input type="textarea" placeholder="请输入PC端产品办理链接" v-model="saveData.pc_link" size="mini" clearable></el-input>
        </el-form-item>
        <el-form-item label="小程序端产品办理链接">
            <el-input type="textarea" placeholder="请输入小程序端产品办理链接" v-model="saveData.mini_link" size="mini" clearable></el-input>
        </el-form-item>
        <el-divider content-position="left">PC详情页</el-divider>
          <vue-ueditor-wrap v-model="saveData.addition_desc" :config="myConfig" style="margin-bottom:.2rem"></vue-ueditor-wrap>
        <el-divider content-position="left">微信小程序详情页</el-divider>
          <vue-ueditor-wrap v-model="saveData.we_desc" :config="myWeConfig"></vue-ueditor-wrap>
        <el-form-item label="是否显示">
          是
          <el-switch
            v-model="saveData.status"
            active-color="#ff4949"
            inactive-color="#13ce66"
          >
          </el-switch>
          否
        </el-form-item>
        <div class="addCon" style="margin-right: .15rem">
          <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
        </div>
      </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'product_addition',
  components: {
    VueUeditorWrap
  },
  data () {
    return {

      uploadHeader: {Authorization: localStorage.token},
      imgPath: this.$store.state.imgPath,
      ProductAdditionList: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      col: [
        {
          label: 'id',
          prop: 'id'
        },
        {
          label: '标题',
          prop: 'title'
        }
      ],
      addDrawer: false,
      editDrawer: false,
      direction: 'rtl',
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 100,
        initialFrameWidth: '100%',
        serverUrl: this.$store.state.serverUrlStudy,
        zIndex: 9999,
        toolbars: [[
          'fullscreen', 'source', '|', 'undo', 'redo', '|',
          'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat',
          'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor',
          'selectall', 'cleardoc', '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'paragraph', 'fontfamily', 'fontsize', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', 'indent', '|',
          'touppercase', 'tolowercase', 'imageleft', 'imageright', 'imagecenter', 'simpleupload', 'emotion', 'preview'
        ]]
      },
      myWeConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 100,
        initialFrameWidth: '100%',
        serverUrl: this.$store.state.serverUrlStudy,
        zIndex: 9999,
        toolbars: [[
          'fullscreen', 'source', '|', 'undo', 'redo', '|',
          'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat',
          'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor',
          'selectall', 'cleardoc', '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'paragraph', 'fontfamily', 'fontsize', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', 'indent', '|',
          'touppercase', 'tolowercase', 'imageleft', 'imageright', 'imagecenter', 'simpleupload', 'emotion', 'preview'
        ]]
      },
      addData: {
        addition_title: '',
        addition_contract: '',
        addition_desc: '',
        we_desc: '',
        status: false,
        pc_link: '',
        mini_link: ''
      },
      saveData: {
        id: null,
        index: null,
        addition_title: '',
        addition_contract: '',
        addition_desc: '',
        we_desc: '',
        status: false,
        pc_link: '',
        mini_link: ''
      },
      searchLoading: false,
      searchArr: {
        category_id: ''
      },
      searchCategories: [],
      // 初始化列表是否显示开关
      ListIfDisplay: [],
      searcher: null
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development' ? '' : 'https://weixin.qiyehuo.com'
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
    // pageData: {
    //   get: function () {
    //     return this.ProductAdditionList.slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
    //   }
    // }
  },
  methods: {
    getProductAdditionData () {
      this.$axios.get('/api/product_addition/get_list', {
        params: {
          page: this.pageOption.currentPage,
          perpage: this.pageOption.pageSize,
          searchItem: this.searcher
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 1) {
            this.ProductAdditionList = data.data.data
            this.pageOption.total = data.data.total
            this.loadRadio()
          }
        }
        )
    },
    loadRadio () {
      this.ProductAdditionList.map(item => {
        if (item.status === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.loadTable()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getProductAdditionData()
    },
    handleAddDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {})
    },
    handleAddOpen () {
      this.addDrawer = true
    },
    handleAdd () {
      if (!this.addData.addition_title) {
        this.$message.error('标题不能为空！')
        return
      }
      if (!this.addData.addition_contract) {
        this.$message.error('简介不能为空！')
        return
      }
      if (!this.addData.addition_desc || !this.addData.we_desc) {
        this.$message.error('内容不能为空！')
        return
      }
      this.$axios.post('/api/product_addition/create', {
        title: this.addData.addition_title,
        contract: this.addData.addition_contract,
        description: this.addData.addition_desc,
        we_desc: this.addData.we_desc,
        status: this.addData.status === false ? 1 : 0,
        pc_link: this.addData.pc_link,
        mini_link: this.addData.mini_link
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.ProductAdditionList.unshift(data.data)
          this.pageOption.total = this.ProductAdditionList.length
          this.$message.success(data.msg)
          this.getProductAdditionData()
          this.clearAddData()
          this.addDrawer = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleEdit (index, row) {
      this.saveData.id = row.id
      this.saveData.index = index
      this.saveData.addition_title = row.title
      this.saveData.addition_contract = row.contract
      this.saveData.pc_link = row.pc_link
      this.saveData.mini_link = row.mini_link
      this.saveData.addition_desc = row.description
      this.saveData.we_desc = row.we_desc
      if (row.status === 1) {
        this.saveData.status = false
      } else {
        this.saveData.status = true
      }
      this.editDrawer = true
    },
    handleEditDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {})
    },
    handleSave () {
      if (!this.saveData.id) {
        this.$message.error('请求错误！')
        return
      }
      if (this.saveData.index === null) {
        this.$message.error('请求错误！')
        return
      }
      if (!this.saveData.addition_title) {
        this.$message.error('标题不能为空！')
        return
      }
      if (!this.saveData.addition_desc || !this.saveData.we_desc) {
        this.$message.error('详情内容不能为空！')
        return
      }
      this.$axios.post('/api/product_addition/update/' + this.saveData.id, {
        title: this.saveData.addition_title,
        contract: this.saveData.addition_contract,
        description: this.saveData.addition_desc,
        we_desc: this.saveData.we_desc,
        status: this.saveData.status === false ? 1 : 0,
        pc_link: this.saveData.pc_link,
        mini_link: this.saveData.mini_link
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.$message.success(data.msg)
          this.getProductAdditionData()
          this.clearSaveData()
          this.editDrawer = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    clearAddData () {
      this.addData.addition_title = ''
      this.addData.addition_contract = ''
      this.addData.pc_link = ''
      this.addData.mini_link = ''
      this.addData.addition_desc = ''
      this.addData.we_desc = ''
      this.addData.status = false
    },
    clearSaveData () {
      this.saveData.id = null
      this.saveData.index = null
      this.saveData.addition_title = ''
      this.saveData.addition_contract = ''
      this.saveData.pc_link = ''
      this.saveData.mini_link = ''
      this.saveData.addition_desc = ''
      this.saveData.we_desc = ''
      this.saveData.status = false
    },
    prePage () {
      if (this.pageOption.currentPage === 1) return
      this.pageOption.currentPage = this.pageOption.currentPage - 1
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      setTimeout(() => {
        this.getProductAdditionData()
      })
    },
    searchItem (query) {
      this.$axios
        .get('api/product_addition/gettitle', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    // 修改列表单条数据是否显示
    editListRadio (row) {
      this.$axios
        .put('api/product_addition/switch_show_hidden', {
          id: row.id,
          status: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.getProductAdditionData()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    }
  },
  mounted () {
    this.getProductAdditionData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .product_addition >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .product_addition
    marginLeft()
  .el-dialog__wrapper >>> .el-drawer
    overflow-y: auto
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
  .addCon
    margin: .2rem 0
    text-align: right
  .el-row
    margin-bottom: .2rem
  .el-select
    width: 100%
  .avatar-uploader
    text-align: center
    margin-bottom: .2rem
  .avatar-uploader >>> .el-upload
    border: .02rem dashed #d9d9d9
    border-radius: .12rem
    cursor: pointer
    position: relative
    overflow: hidden
  .avatar-uploader >>> .el-upload:hover
    border-color: #409eff
  .avatar-uploader >>> .el-upload img
    width: 4rem
    height: 2rem
  .avatar-uploader-icon
    font-size: .4rem
    color: #8c939d
    width: 4rem
    height: 2rem
    line-height: 2rem
    text-align: center
  .add-drawer >>> .rtl
    overflow: auto !important
</style>



// WEBPACK FOOTER //
// src/pages/product_addition/product_addition.vue